import { Phone, Mail, MapPin } from "lucide-react";
import { CLINIC, HEALTH_FUNDS } from "@/data";

const links = [
  ["About Us", "#about"],
  ["Meet Winston", "#winston"],
  ["Our Services", "#services"],
  ["Free Kids Dental", "#kids"],
  ["Smile Gallery", "#gallery"],
  ["Book Appointment", "#contact"],
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-pd-forest text-pd-bg/80">
      {/* Big CTA */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-14 border-b border-white/10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8">
          <h2 className="font-display text-5xl md:text-7xl font-light leading-none text-pd-bg">
            Let's get you <br /><span className="italic text-pd-accent">smiling.</span>
          </h2>
          <div className="flex flex-col sm:flex-row gap-4">
            <a href={`tel:${CLINIC.phoneRaw}`} data-testid="footer-call-btn" className="inline-flex items-center justify-center gap-2 border border-white/30 hover:bg-white hover:text-pd-forest text-pd-bg rounded-full px-7 py-3.5 font-medium transition-all duration-300">
              <Phone size={18} /> {CLINIC.phoneDisplay}
            </a>
            <a href="#contact" data-testid="footer-book-btn" className="inline-flex items-center justify-center gap-2 bg-pd-terra hover:bg-pd-terradark text-white rounded-full px-7 py-3.5 font-medium transition-all duration-300">
              Book Appointment
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="mb-4">
            <img src="/pd-logo-white.png" alt="Proactive Dental" className="h-10 w-auto" />
          </div>
          <p className="text-sm leading-relaxed text-pd-bg/60">
            Gentle, affordable dentistry serving Burpengary, Morayfield, Narangba & Deception Bay since 2010.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-pd-sage mb-4">Explore</h4>
          <ul className="space-y-2.5">
            {links.map(([l, h]) => (
              <li key={l}><a href={h} className="text-sm text-pd-bg/70 hover:text-pd-accent transition-colors">{l}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-pd-sage mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-pd-bg/70">
            <li className="flex items-start gap-2.5"><MapPin size={16} className="text-pd-accent mt-0.5 shrink-0" />{CLINIC.address}</li>
            <li className="flex items-center gap-2.5"><Phone size={16} className="text-pd-accent shrink-0" /><a href={`tel:${CLINIC.phoneRaw}`} className="hover:text-pd-accent">{CLINIC.phoneDisplay}</a></li>
            <li className="flex items-center gap-2.5"><Mail size={16} className="text-pd-accent shrink-0" /><a href={`mailto:${CLINIC.email}`} className="hover:text-pd-accent break-all">{CLINIC.email}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-pd-sage mb-4">Health Funds</h4>
          <div className="flex flex-wrap gap-2">
            {HEALTH_FUNDS.map((f) => (
              <span key={f} className="text-xs font-medium bg-white/10 rounded-full px-3 py-1.5 text-pd-bg/80">{f}</span>
            ))}
          </div>
          <p className="mt-4 text-xs text-pd-bg/50">HICAPS on-the-spot claiming available.</p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-pd-bg/50">
          <span>© {new Date().getFullYear()} Proactive Dental Surgery Burpengary. All rights reserved.</span>
          <span>Designed for healthier, happier smiles.</span>
        </div>
      </div>
    </footer>
  );
}
